import {DatePipe} from '@angular/common';
import {ChangeDetectorRef, Component, OnInit, ViewChild,} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {vappeloffre} from 'src/app/domain';
import {SearchOptions} from 'src/app/domain/offre';
import {Pagination} from 'src/app/domain/Pagination';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {PaginatorComponent} from 'src/app/modules/widget/components/paginator/paginator.component';
import {isEmpty} from 'src/app/utils/is-empty';
import {SharedSearchService} from '../accueil/common/shared-search.service';
import {OffersTableComponent} from './offers-table/offers-table.component';
import {CriteriaSearch} from '../../../domain/CriteriaSearch';

export interface SearchView<T> {
    loading: boolean;
    options: any;
    count: number;
    results: T[];
}

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html',
    styleUrls: ['./offers.component.css'],
})
export class OffersComponent implements OnInit {

    @ViewChild(OffersTableComponent) tableComponent: OffersTableComponent;
    @ViewChild(PaginatorComponent) p: PaginatorComponent;
    offers: vappeloffre[] = [];
    searchOptions?: Partial<SearchOptions>;
    searchObject: SearchObject;
    count: number;

    searchh: SearchView<vappeloffre> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoading = {
        list: false,
    };

    constructor(
        private datePipe: DatePipe,
        private toast: ToastService,
        private dialog: MatDialog,
        private offerservice: AppeloffreService,
        private searchObjectService: SearchObjectService,
        private router: Router,
        private changeDetectorRefs: ChangeDetectorRef,
        private sharedService: SharedSearchService
    ) {
        // if(Promise.resolve(this.router.getCurrentNavigation().extras.state.count)===null)
        // {
        //   this.initDataList();
        // }
        // else
        // {  this.isLoading.list = true;
        //   this.searchh.results = this.router.getCurrentNavigation().extras.state.data;
        //   this.searchh.count = this.router.getCurrentNavigation().extras.state.count;
        //   this.searchh.results.filter((column) => {
        //     this.datePipe.transform(column.bdRecvEndDt,"yyyy-MM-dd")
        //     //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
        //   });
        // }
    }

    ngOnInit(): void {
        this.searchObject = this.searchObjectService.treatementSearchObject(
            10,
            0,
            'publicDt',
            'desc nulls last'
        );
        this.initDataList();
    }

    initDataList() {
        this.isLoading.list = true;

        this.searchObject.dataSearch.push(new CriteriaSearch("publicYn", "Y", "="));
        if (!isEmpty(this.sharedService.compOffreVal?.value)) {
            this.searchObject.dataSearch.push(this.sharedService.compOffreVal);
        }
        this.offerservice.search(this.searchObject).subscribe({
            next: (response) => {
                this.searchh.results = response['payload']['data'];
                this.searchh.count = response['payload']['total'];
                this.searchh.results.filter((column) => {
                    this.datePipe.transform(column.bdRecvEndDt, 'yyyy-MM-dd');
                    //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
                });
            },
            error: () => {
                this.isLoading.list = false;
                this.toast.error('server_error');
            },
            complete: () => {
                this.isLoading.list = false;
            },
        });
    }

    onPaginate(pagination: Pagination) {
        this.searchObject.pagination = pagination;
        this.initDataList();
    }

    onSearch($event) {
        this.searchObject.pagination.offSet = 0;
        this.searchObject.pagination.limit = 10;
        this.p.paginator.pageIndex = 0;
        this.searchObject.dataSearch = [];
        this.searchObject.dataSearch = $event;

        this.initDataList();
    }

    onSort(sort: any) {
        this.searchObject.sort = sort;

        this.onSearch(this.searchObject.dataSearch);
    }
}
